/**
 * Typdefinitioner för OrganizationChart
 * Grafisk visualisering av organisationshierarki med ReactFlow
 */

import { Node, Edge, MarkerType } from 'reactflow';

export interface OrganizationNodeData {
  label: string;
  description?: string;
  isTopNode: boolean;
  isNew?: boolean;
  organizationId?: string;
}

export interface AddModalState {
  show: boolean;
  name: string;
  description: string;
  parentId: string;
}

// Default edge style
export const DEFAULT_EDGE_STYLE = {
  type: 'smoothstep' as const,
  markerEnd: { type: MarkerType.ArrowClosed, color: '#6b7280' },
  style: { stroke: '#6b7280', strokeWidth: 2 },
};

// Dagre layout settings
export const DAGRE_SETTINGS = {
  nodeWidth: 200,
  nodeHeight: 60,
  rankdir: 'TB',
  nodesep: 80,
  ranksep: 100,
  marginx: 50,
  marginy: 50,
};

export const createEdge = (sourceId: string, targetId: string): Edge => ({
  id: `${sourceId}-${targetId}`,
  source: sourceId,
  target: targetId,
  ...DEFAULT_EDGE_STYLE,
});

export const createNewOrganizationNode = (
  id: string,
  name: string,
  description: string,
  position: { x: number; y: number }
): Node<OrganizationNodeData> => ({
  id,
  type: 'organization',
  position,
  data: {
    label: name,
    description,
    isTopNode: false,
    isNew: true,
  },
});
